module.exports = __webpack_public_path__ + "static/media/usage-sample.202af04b.svg";